import { http } from '../../../../api/http';
import type {
  Actividad, Labor, Consumidor, GrupoTrabajo, CostoActividad,
  AsistenciaRendimiento, RendimientoResumen,
  SaveRendimientoRequest, GrupoTrabajadorResumen,
} from '../types/rendimiento';

const EP = '/planilla/rendimiento';

export class RendimientoService {
  // ── Actividades ──
  static async getActividades(): Promise<Actividad[]> {
    const r = await http.get(`${EP}/actividades`);
    return r.data;
  }
  static async saveActividad(data: Partial<Actividad>): Promise<Actividad> {
    const r = await http.post(`${EP}/actividades`, data);
    return r.data;
  }
  static async deleteActividad(id: number): Promise<void> {
    await http.delete(`${EP}/actividades/${id}`);
  }

  // ── Labores ──
  static async getLabores(idActividad?: number): Promise<Labor[]> {
    const params: Record<string, number> = {};
    if (idActividad) params.idActividad = idActividad;
    const r = await http.get(`${EP}/labores`, { params });
    return r.data;
  }
  static async saveLabor(data: Partial<Labor>): Promise<Labor> {
    const r = await http.post(`${EP}/labores`, data);
    return r.data;
  }
  static async deleteLabor(id: number): Promise<void> {
    await http.delete(`${EP}/labores/${id}`);
  }

  // ── Consumidores ──
  static async getConsumidores(): Promise<Consumidor[]> {
    const r = await http.get(`${EP}/consumidores`);
    return r.data;
  }
  static async saveConsumidor(data: Partial<Consumidor>): Promise<Consumidor> {
    const r = await http.post(`${EP}/consumidores`, data);
    return r.data;
  }
  static async deleteConsumidor(id: number): Promise<void> {
    await http.delete(`${EP}/consumidores/${id}`);
  }

  // ── Grupos Trabajo ──
  static async getGruposTrabajo(): Promise<GrupoTrabajo[]> {
    const r = await http.get(`${EP}/grupos-trabajo`);
    return r.data;
  }
  static async saveGrupoTrabajo(data: Partial<GrupoTrabajo>): Promise<GrupoTrabajo> {
    const r = await http.post(`${EP}/grupos-trabajo`, data);
    return r.data;
  }
  static async deleteGrupoTrabajo(id: number): Promise<void> {
    await http.delete(`${EP}/grupos-trabajo/${id}`);
  }

  // ── Grupo Trabajador (asignaciones) ──
  static async getTrabajadoresGrupo(idGrupoTrabajo: number): Promise<GrupoTrabajadorResumen[]> {
    const r = await http.get(`${EP}/grupos-trabajo/${idGrupoTrabajo}/trabajadores`);
    return r.data;
  }
  static async asignarTrabajadoresGrupo(idGrupoTrabajo: number, idTrabajadores: number[]): Promise<void> {
    await http.post(`${EP}/grupos-trabajo/${idGrupoTrabajo}/trabajadores`, idTrabajadores);
  }
  static async removerTrabajadorGrupo(id: number): Promise<void> {
    await http.delete(`${EP}/grupos-trabajo/trabajadores/${id}`);
  }

  // ── Costos Actividad ──
  static async getCostosActividad(idActividad: number): Promise<CostoActividad[]> {
    const r = await http.get(`${EP}/costos-actividad/${idActividad}`);
    return r.data;
  }
  static async saveCostoActividad(data: Partial<CostoActividad>): Promise<CostoActividad> {
    const r = await http.post(`${EP}/costos-actividad`, data);
    return r.data;
  }
  static async deleteCostoActividad(id: number): Promise<void> {
    await http.delete(`${EP}/costos-actividad/${id}`);
  }

  // ── Documentos ──
  static async getDocumentos(idPeriodo: number): Promise<AsistenciaRendimiento[]> {
    const r = await http.get(`${EP}/documentos/periodo/${idPeriodo}`);
    return r.data;
  }
  static async getDocumentoCompleto(id: number): Promise<AsistenciaRendimiento> {
    const r = await http.get(`${EP}/documentos/${id}/completo`);
    return r.data;
  }
  static async saveDocumento(request: SaveRendimientoRequest): Promise<AsistenciaRendimiento> {
    const r = await http.post(`${EP}/documentos`, request);
    return r.data;
  }
  static async deleteDocumento(id: number): Promise<void> {
    await http.delete(`${EP}/documentos/${id}`);
  }
  static async cambiarEstado(id: number, estado: string): Promise<AsistenciaRendimiento> {
    const r = await http.put(`${EP}/documentos/${id}/estado`, { estado });
    return r.data;
  }

  // ── Resumen ──
  static async getResumen(idPeriodo: number): Promise<RendimientoResumen> {
    const r = await http.get(`${EP}/resumen/periodo/${idPeriodo}`);
    return r.data;
  }
}
